import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentTypeProps as Props } from './types';
import {
  getEnrichmentIconColor,
  getEnrichmentIconName,
  getEnrichmentTypeLabel,
} from './utils';

export const EnrichmentType = memo(({ className, type }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('EnrichmentType', className)}
      sx={SX.root}
      direction="row"
    >
      <Icon
        name={getEnrichmentIconName(type)}
        color={getEnrichmentIconColor(type)}
        size={18}
      />
      <Typography variant="body3" color="grey.700" fontWeight={400}>
        {getEnrichmentTypeLabel(type)}
      </Typography>
    </Styled.Wrapper>
  );
});

EnrichmentType.displayName = 'EnrichmentType';
